import { SearchSuggestion } from "@/domains/search";

export const searchSort = (a: SearchSuggestion, b: SearchSuggestion): number =>
  b.sortKey - a.sortKey;
